export default __webpack_public_path__ + "static/media/Zainab_9781408359945.a2817da7.jpg";